import React, { FC } from 'react'
import styled from 'styled-components'
import Lottie from 'react-lottie-player'
import { theme, Text } from 'ui'
import protocolsTabIcon from 'assets/tabAnimation/icon_8.json'

// The shared Empty component falls back to the messaging artwork and its "write
// a new message" copy for any prop a caller leaves out, which is how a chat
// illustration ended up on the protocol screens. This one has nothing to fall
// back to: it shows the protocols tab icon and whatever it is given.
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  gap: 4px;
`

const ProtocolsEmpty: FC<{ title?: string; description?: string }> = ({ title, description }) => (
  <Wrap>
    {/* The tab's own icon, held on its first frame rather than played - the tab
        animates on selection, an empty state has nothing to announce. */}
    <Lottie animationData={protocolsTabIcon} play={false} style={{ width: 64, height: 64 }} />
    {title && (
      <Text style={{ paddingTop: 10 }} textcolor={theme.color.black} size='xxl' weight='medium'>
        {title}
      </Text>
    )}
    {description && (
      <Text style={{ paddingTop: 6 }} textcolor={theme.color.black + 99} size='lg' weight='medium'>
        {description}
      </Text>
    )}
  </Wrap>
)

export default ProtocolsEmpty
